import { IUpdateOrgAppRequest } from '../hopper/octopus/client';
import { Component, OnInit, Input, Inject } from '@angular/core';
import { Modalidade } from '../models/modalidade';
import { UtilitarioService } from '../services/utilitario.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { ModalidadeService } from '../services/modalidade.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

declare const $: any;

@Component({
  selector: 'app-modalidade',
  templateUrl: './modalidade.component.html',
  styleUrls: ['./modalidade.component.scss']
})
export class ModalidadeComponent implements OnInit {
  @Input() idTransportadora: string;

  modalidades: Modalidade[] = [];
  novaMod: Modalidade = new Modalidade();
  criarModalidade: boolean = false;
  grupos: string[] = [];
  grupoSelecionado: string;
  editandoMod = null;
  tiposDeStatus = [{ id: 0, nome: 'Bloqueado' }, { id: 1, nome: 'Ativo' }];
  statusSelecionado = 1;
  tiposDeStatusModalidade = [{ id: -1, nome: 'Todos' }, { id: 1, nome: 'Ativo' }, { id: 0, nome: 'Bloqueado' }];
  statusModalidadeSelecionado = 1;
  tiposFreteModalidade = [ { id: 0, nome: 'CIF' }, { id: 1, nome: 'FOB' }];
  tipoFreteModalidadeSelecionado = 0;
  semTransp: boolean = false;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<ModalidadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public utilitarioService: UtilitarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private modalidadeService: ModalidadeService
  ) { }

  ngOnInit() {
    this.semTransp = this.idTransportadora == null || this.idTransportadora == undefined;

    this.buscarModalidades();
    this.buscarGrupos();
  }

  buscarModalidades() {
    this.carregandoService.mostra('buscaModalidades');

    this.modalidadeService.listarModalidades(this.statusModalidadeSelecionado, this.semTransp, this.idTransportadora).subscribe(data => {
      this.modalidades = data;
      this.carregandoService.esconde('buscaModalidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaModalidades');
      this.notificacaoService.erro(`Não foi possível buscar modalidades. Erro: ${erro}`);
    });
  }

  buscarGrupos() {
    this.carregandoService.mostra('buscaGrupos');
    this.modalidadeService.listarGrupos().subscribe(data => {
      this.grupos = data;
      this.carregandoService.esconde('buscaGrupos');
    }, (erro) => {
      this.carregandoService.esconde('buscaGrupos');
      this.notificacaoService.erro('Não foi possível buscar os grupos existentes');
    });
  }

  novaModalidade() {
    this.criarModalidade = true;

    this.novaMod = new Modalidade();
    this.novaMod.status = 1;
    this.novaMod.idTransp = Number(this.idTransportadora);
    this.novaMod.tipoFrete = 0;
    this.focalizaDescricao();
  }

  editarModalidade(modalidade: Modalidade) {
    this.novaMod = modalidade;
    this.grupoSelecionado = this.novaMod.grupo;
    this.editandoMod = modalidade.id;

    modalidade.editando = true;
  }

  cancelarNovaModalidade() {
    this.criarModalidade = false;
    this.editandoMod = null;
    this.novaMod = new Modalidade();
  }

  salvarNovaModalidade() {
    if (this.novaMod.padrao)
      this.novaMod.padrao = 1;
    else
      this.novaMod.padrao = 0;

    if (this.verificaPadrao(this.novaMod, 1)) return;

    if (this.novaMod.editando == false && this.verificaNomeExistente(this.novaMod.descricao)) {
      this.notificacaoService.erro(`Já existe uma modalidade com o nome '${this.novaMod.descricao}'`);
      this.focalizaDescricao();
      return;
    }

    this.criarModalidade = false;
    this.editandoMod = null;

    this.carregandoService.mostra('atualizaModalidade');
    this.modalidadeService.salvar(this.novaMod).subscribe(data => {
      this.carregandoService.esconde('atualizaModalidade');
      this.notificacaoService.sucesso('Atualizado!');

      this.statusModalidadeSelecionado = this.novaMod.status;

      this.buscarModalidades();
    }, (erro) => {
      this.carregandoService.esconde('atualizaModalidade');
      this.notificacaoService.erro('Não foi possível atualizar!');
    });
  }

  excluirModalidade(novaMod: Modalidade) {
    if (this.verificaPadrao(novaMod, 0)) return;

    this.carregandoService.mostra('excluiModalidade');

    this.modalidadeService.excluir(novaMod.id).subscribe(resp => {
      this.carregandoService.esconde('excluiModalidade');
      this.notificacaoService.sucesso("Modalidade excluída com sucesso!");

      this.buscarModalidades();
    }, (erro) => {
      this.carregandoService.esconde('excluiModalidade');
      this.notificacaoService.erro("Não foi possível excluir esta modalidade;");
      console.error('Erro: ', erro);
    });
  }

  verificaPadrao(novaMod: Modalidade, tipo: number = -1): boolean {
    const erroPadraoBloqueio = 'Não é possível bloquear uma modalidade padrão!';
    const erroPadraoExclusao = 'Não é possível excluir uma modalidade padrão!';
    const erroPadraoAusente = 'É necessário ter uma modalidade como padrão!';

    if (novaMod.padrao && novaMod.status === 0) {
      this.notificacaoService.erro(erroPadraoBloqueio);
      this.buscarModalidades();
      return true;
    }

    if (novaMod.padrao && tipo === 0) {
      this.notificacaoService.erro(erroPadraoExclusao);
      this.buscarModalidades();
      return true;
    }

    if (tipo === 1 && this.modalidades.length > 0) {
      const modalidadePadrao = this.modalidades.find(m => m.padrao);
      const idPadrao = modalidadePadrao ? modalidadePadrao.id : null;
      const isNovaModPadraoInvalido = novaMod.id === idPadrao && novaMod.padrao === 0;
      const isPadraoAusente = idPadrao === null;

      if (this.statusModalidadeSelecionado != 0 && novaMod.status === 1 && (isNovaModPadraoInvalido || isPadraoAusente)) {
        this.notificacaoService.erro(erroPadraoAusente);
        this.criarModalidade = false;
        this.editandoMod = null;
        this.buscarModalidades();

        return true;
      }
    }

    return false;
  }

  verificaNomeExistente(nome: string): boolean {
    return this.modalidades.some(m => m.descricao.includes(nome));
  }

  focalizaDescricao() {
    $('#descricaoNovo').focus();
  }

  fechar() {
    this.dialogRef.close();
  }
}
